import { gqlMutate, gqlQuery } from '@hapana/shared/web/services/requests.service'
import { CLIENT_MOCK } from '@hapana/shared/web/mocks/client.mock'

import {
  checkIn,
  checkIns,
  getLatestTanningCheckIn as getLatestTanningCheckInQuery,
} from './graphql/check-in.queries'
import * as mutations from './graphql/check-in.mutations'

const checkInsMockResponse = {
  checkins: {
    results: [
      {
        node: {
          clientId: '627eae7754567f6eb9d80f84',
          datetime: '2022-05-04T12:45:52.144Z',
          payments: {
            outstanding: [],
            failed: [],
          },
          client: CLIENT_MOCK,
        },
      },
      {
        node: {
          clientId: '627eae7754567f6eb9d80f84',
          datetime: '2022-05-04T12:45:52.144Z',
          payments: {
            outstanding: [
              {
                label: 'Membership',
              },
            ],
            failed: [
              {
                label: 'Membership',
              },
              {
                label: 'Membership',
              },
            ],
          },
          client: CLIENT_MOCK,
        },
      },
      {
        node: {
          clientId: '627eae7754567f6eb9d80f84',
          datetime: '2022-05-04T12:45:52.144Z',
          payments: {
            outstanding: [
              {
                label: 'Membership',
              },
            ],
            failed: [
              {
                label: 'Membership',
              },
              {
                label: 'Membership',
              },
            ],
          },
          client: CLIENT_MOCK,
        },
      },
      {
        node: {
          clientId: '627eae7754567f6eb9d80f84',
          datetime: '2022-05-04T12:45:52.144Z',
          payments: {
            outstanding: [
              {
                label: 'Membership',
              },
            ],
            failed: [
              {
                label: 'Membership',
              },
              {
                label: 'Membership',
              },
            ],
          },
          client: CLIENT_MOCK,
        },
      },
      {
        node: {
          clientId: '627eae7754567f6eb9d80f84',
          datetime: '2022-05-04T12:45:52.144Z',
          payments: {
            outstanding: [
              {
                label: 'Membership',
              },
            ],
            failed: [
              {
                label: 'Membership',
              },
              {
                label: 'Membership',
              },
            ],
          },
          client: CLIENT_MOCK,
        },
      },
    ],
  },
}
const checkInMockResponse = {
  checkin: {
    clientId: '627eae7754567f6eb9d80f84',
    datetime: '2022-05-04T12:45:52.144Z',
    payments: {
      outstanding: [],
      failed: [],
    },
    client: CLIENT_MOCK,
  },
}

export const getCheckIns = gqlQuery({
  key: 'CHECKINS_DATA',
  query: checkIns,
  mockResponse: checkInsMockResponse,
})
export const getCheckIn = gqlQuery({
  key: 'CHECKIN_DATA',
  query: checkIn,
  mockResponse: checkInMockResponse,
})
export const addClientPrivateNote = ({ siteId, clientId, text, date }) =>
  gqlMutate({
    mutation: mutations.addClientPrivateNote,
    variables: {
      clientId,
      siteId,
      text,
      date,
    },
  })

export const createCheckIn = ({ siteId, clientId }) =>
  gqlMutate({
    mutation: mutations.createCheckIn,
    variables: {
      clientId,
      siteId,
      source: 'WIDGET',
    },
  })

export const createTanningCheckIn = ({ siteId, clientId }) =>
  gqlMutate({
    mutation: mutations.createTanningCheckIn,
    variables: {
      clientId,
      siteId,
      source: 'WIDGET',
    },
  })

export const getLatestTanningCheckIn = gqlQuery({
  key: 'LATEST_TANNING_CHECK_IN',
  query: getLatestTanningCheckInQuery,
})
